import ViewCategoryButton from './ViewCategoryButton'

export default ViewCategoryButton
